export const CUSTOMER_SLACK_FLAG = "customer-slack";
export const DARK_MODE_FLAG = "dark-mode";
export const MEMBERSHIP_MANAGEMENT_FLAG = "membership-management-page";
// Client components read it by key; the server reads the AudioReels flag with the same key.
export const AUDIO_REELS_FLAG = "audio-reels";
// Study advisor v2: anchored issues written to study_issues.
export const OPTIONAL_QUESTIONS_FLAG = "optional-questions";
export const STUDY_COMMENTS_FLAG = "study-comments";
export const PRESENTATION_KEYNOTE_DOWNLOAD_FLAG =
  "presentation-keynote-download";
// Compares file uploads against reference images on the question. Allow-list
// by org or study so the editor and the interview agree; a user entry only
// reveals the editor section, since the interview has no user to check.
export const UPLOAD_VERIFICATION_FLAG = "upload-verification";
// Org-level: only reveals the study's auto-advance setting; runtime reads enable_auto_advance.
export const AUTO_ADVANCE_FLAG = "auto-advance";
export const FULL_MATRIX_LAYOUT_FLAG = "full-matrix-layout";
